/** @jsx jsx */
import { jsx, } from "theme-ui";
import { Box } from '@theme-ui/components'
import { FC } from "react";

export const Users: FC = () => {
  return <Box />
}